import InspectionTask from "./InspectionTask";

export default InspectionTask;